module.exports = __webpack_public_path__ + "media/swapp_signin.a0f4e83e.mp3";